import type {
  BenchmarkJudgeOnlyProviderSummary,
  BenchmarkProviderSummary,
} from "./types";

export interface JudgeOnlyProviderView {
  summary: BenchmarkJudgeOnlyProviderSummary | null;
  badOrUnresolvedRate: number | null;
  materialErrorRate: number | null;
  materialErrors: number | null;
  decisiveCells: number | null;
  legacyFallback: boolean;
}

export function judgeOnlyProviderView(
  provider: BenchmarkProviderSummary,
): JudgeOnlyProviderView {
  if (provider.judge_only) {
    return {
      summary: provider.judge_only,
      badOrUnresolvedRate: provider.judge_only.bad_or_unresolved_rate,
      materialErrorRate: provider.judge_only.material_error_rate,
      materialErrors: provider.judge_only.material_errors,
      decisiveCells: provider.judge_only.decisive_cells,
      legacyFallback: false,
    };
  }
  const rate = provider.semantic_judge_material_error_rate;
  return {
    summary: null,
    badOrUnresolvedRate: rate,
    materialErrorRate: rate,
    materialErrors:
      rate == null ? null : Math.round(rate * provider.semantic_judge_scored),
    decisiveCells:
      rate == null ? null : provider.semantic_judge_scored,
    legacyFallback: rate != null,
  };
}

export function judgeOnlyRateDelta(
  view: JudgeOnlyProviderView,
  humanBadOutcome: number | null | undefined,
): number | null {
  if (
    view.legacyFallback
    || view.badOrUnresolvedRate == null
    || humanBadOutcome == null
  ) {
    return null;
  }
  return view.badOrUnresolvedRate - humanBadOutcome;
}

export function judgeOnlySliceCounts(
  decisiveCells: number | undefined,
  eligibleCells: number | undefined,
): { decisiveCells: number; eligibleCells: number } | null {
  if (decisiveCells == null || eligibleCells == null) return null;
  return { decisiveCells, eligibleCells };
}
